import { render, staticRenderFns } from "./SearchRoles.vue?vue&type=template&id=9ee1ba50"
import script from "./SearchRoles.vue?vue&type=script&lang=js"
export * from "./SearchRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports